//getCall
const getCallMethod = async (apiEndPoint) => {
    try {
        const response = await fetch(apiEndPoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('accessToken')
            }
        });

        console.log("GET response status:", response.status);
        console.log("GET response:", response);

        const data = await response.json();

        console.log("GET RESPONSE DATA:", data);

        if (response.status === 200) {
            return data;
        } else {
            throw data;
        }

    } catch (err) {
        throw err;
    }
};


//postCall
const postCallMethod = async(apiEndPoint, payload)=>{
    try {
        console.log("httpServer.js POST apiEndPoint", apiEndPoint)
        const response = await fetch(apiEndPoint,{
            method: 'POST',
            headers:{
                'Content-Type': 'application/json',
                // 'access_token': localStorage.getItem('sid')
            },
            body: JSON.stringify(payload)
        })
        console.log("httpServer.js POST response", response)
        if(response.status === 200){
            return response.json()
        }else{
            const errorResponse = await response.json();
            throw errorResponse; // Throw the error response object
        }

    } catch (err) {
        throw err
    }

}

const httpService= {
    getCallMethod,
    postCallMethod
}
export default httpService; 